export function throttle(fn: (...args: any[]) => any, time: number) {
  let isGoing = false;
  return (...params: any[]) => {
    if (isGoing) return;
    isGoing = true;
    fn.apply(null, [...params]);
    setTimeout(() => {
      isGoing = false;
    }, time);
  };
}
